export enum scannerActiveState
{
    Scanner_START = "scanner_start",
    Scanner_Init = "scanner_init",
    Scanner_WaitingForData = "scanner_waiting",
    Scanner_ReceivedData = "scanner_receiveddata",
    Scanner_ScanFinished = "scanner_finished",
}



export abstract class ScannerState {
    protected context: Context = new Context(this);

    public setContext(context: Context) {
        this.context = context;
    }

    public abstract init(): void;

    public abstract waitingForData(): void;

    public abstract dataReceived(): void;

    public abstract scanFinished(): void;
}


export class Context {
 
    private state: ScannerState;
    public activeState:scannerActiveState = scannerActiveState.Scanner_START;

    constructor(state: ScannerState) {
        
        this.state = state;
       
        this.transitionTo(state);
    }

 
    public transitionTo(state: ScannerState): void {
        this.state = state;
        this.state.setContext(this);
    }

    
    public init(): void {
        this.activeState = scannerActiveState.Scanner_Init;
        this.state.init();
    }

    public waitingForData(): void {
        this.activeState = scannerActiveState.Scanner_WaitingForData;
        this.state.waitingForData();
    }

    public dataReceived(): void {
        this.activeState = scannerActiveState.Scanner_ReceivedData;
        this.state.dataReceived();
    }

    public scanFinished(): void {
        this.activeState = scannerActiveState.Scanner_ScanFinished;
        this.state.scanFinished();
    }
}